<template>
  <v-card :max-width="maxWidth">
    <v-form
      @submit.prevent="submitForm"
      ref="form"
      v-model="valid"
      class="pa-4"
    >
      <h3 class="mb-4 text-center font-weight-regular">
        {{ title }}
      </h3>
      <v-alert
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mx-1 mb-5"
      >
        {{ alertValidate }}
      </v-alert>
      <v-text-field
        name="text"
        v-model="name"
        :label="this.$tc('reports.labelsTitle')"
        outlined
        :rules="rules"
        dense
        class="ma-0"
      />
      <v-text-field
        name="description"
        v-model="description"
        :label="this.$tc('reports.labelsDescription')"
        outlined
        :rules="rules"
        dense
        class="ma-0"
      />
      <v-autocomplete
        name="scope"
        v-model="scope"
        :label="this.$tc('reports.labelsScope')"
        outlined
        :items="typeScope"
        :rules="rules"
        dense
        class="ma-0"
      />
      <v-color-picker
        v-model="color"
        class="mx-auto mb-4"
        :swatches="swatches"
        show-swatches
        hide-canvas
        hide-sliders
        hide-inputs
        value-format="hex"
      />
      <v-text-field
        name="color"
        v-model="color"
        :label="this.$tc('reports.labelsColor')"
        outlined
        hide-details
        dense
        class="ma-0"
        readonly
      />
      <div class="d-flex justify-space-between pt-4">
        <v-btn class="bt-exit" @click="cancel">{{
          $tc("editRegistrations.cancel")
        }}</v-btn>
        <v-btn type="submit" class="bt-acept">
          {{ $tc("editRegistrations.acept") }}</v-btn
        >
      </div>
    </v-form>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      alertValidate: "",
      valid: false,
      name: "",
      description: "",
      color: "#E10000",
      scope: "",
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      error: false,
      swatches: [
        ["#E10000", "#AA0000", "#550000", "#FF00F1"],
        ["#EAEA12", "#AAAA00", "#555500", "#CD00FF"],
        ["#07B207", "#009000", "#005500", "#800080"],
        ["#32D4D4", "#00AAAA", "#005555", "#373BA8"],
        ["#0000CD", "#0000AA", "#000055", "#4500FF"],
      ],
      itemOld: null,
      typeScope: ["reportes", "empleados"],
    };
  },
  props: {
    maxWidth: String,
    mode: String,
    title: String,
  },
  methods: {
    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();

      this.$emit("save", itemsComplete);
    },
    cancel() {
      this.$refs.form.resetValidation();
      this.$emit("cancel", false);
    },
    setInputs() {
      this.name = this.itemOld.text;
      this.description = this.itemOld.description;

      const colorValue = this.itemOld.color;
      this.color =
        typeof colorValue === "object" && colorValue !== null
          ? colorValue.hex || "#E10000"
          : colorValue || "#E10000";

      this.scope = this.itemOld.scope;
    },
  },
  mounted() {
    this.itemOld = this.$store.state.tags.editTag;
    if (this.itemOld !== null && Object.keys(this.itemOld).length !== 0) {
      this.$nextTick(() => {
        this.setInputs();
      });
    }
  },
};
</script>

<style>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
